// extracted by mini-css-extract-plugin
export default {"breakAll":"styles_breakAll__GprSW"};